import React, { useCallback, useMemo } from 'react';
import { useController } from 'react-hook-form';
import TextArea from '../text-area';
import noop from '../../../utils/noop';
import transfromRequiredRule from '../../helpers/transform-required-rule';
const defaultRules = {};

const TextAreaField = ({
  name,
  control,
  rules: passedRules = defaultRules,
  elementAfter = null,
  statusText = '',
  onChange = noop,
  onBlur = noop,
  ...otherProps
}) => {
  const rules = useMemo(() => transfromRequiredRule(passedRules), [passedRules]);

  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (value) => {
      field.onChange(value);
      if (onChange) onChange(value);
    },
    [field, onChange]
  );

  const handleBlur = useCallback(
    (value) => {
      field.onBlur();
      if (onBlur) onBlur(value);
    },
    [field, onBlur]
  );

  const hasElementAfter = Boolean(elementAfter);
  const computedStatusText =
    !hasElementAfter && fieldState.error?.message ? fieldState.error?.message : statusText;

  return (
    <React.Fragment>
      <TextArea
        {...otherProps}
        inputRef={field.ref}
        value={field.value}
        name={field.name}
        invalid={fieldState.invalid}
        statusText={computedStatusText}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {hasElementAfter && elementAfter}
    </React.Fragment>
  );
};

export default TextAreaField;
